<template>
<div>
    <div class="filter-ff">
        <el-input v-model="font_value"></el-input>
    </div>
    <div class="font-ff-ul">
        <ul>
            <li v-for="(item, index) in list_data.list"><span :data="item.font_path">{{ font_value }}</span></li>
        </ul>
        <el-pagination
            class="my-page"
            background
            :page-size="list_data.size"
            layout="total, prev, pager, next"
            @current-change="changePage"
            :total="list_data.total">
        </el-pagination> 
    </div>
</div>
</template>
<script>
import head from '@/pages/public/_head'
import left from '@/pages/public/_left'
export default {
    components:{
        'v-head':head,
        'v-left':left,
    },
    data(){
        return {
            loading:false,
            popName:null,
            font_value:"",
            filter:{
                page:1,
                size:100,
            },
            list_data:{
                size:20,
                page:1,
                total:0,
                list:[],
            },
        }
    },
    methods:{
      changePage(e){
          this.filter.page =e
          this.getList()
      },
      getList(){
          this.loading = true;
          this.$http.post('/v1/pub/tmp/tmp-font-from-taobao-12396596789021096509198238349659090213891231391238901389063840568054', this.filter)
          .then( (response) => {
              this.loading = false;
              var res = response.data;
              if (res.code == 1) {
                  this.list_data = res.data
              }
          })            
      },
    },
    mounted(){
        this.getList()
    },
}
</script>



// WEBPACK FOOTER //
// src/pages/tmp/Font.vue